import { v4 as uuidv4 } from "uuid";
import { getFileExtension } from "@/components/chat/attachments";
import { clinicClock } from "@/lib/clinic-clock";
import { toast } from "@/lib/use-toast";
import { useRefreshSignedUrlMutation } from "@/query/comms/chat";

/**
 * Hook for downloading files with signed URL refresh
 */
export function useFileDownload() {
  const {
    mutateAsync: refreshSignedUrl
  } = useRefreshSignedUrlMutation();
  const download = async (url: string) => {
    try {
      const extension = getFileExtension(url);
      const currentDate = clinicClock().today();
      const uuid = uuidv4().substring(0, 8);
      const newFileName = `${currentDate}-${uuid}${extension}`;
      const refreshedUrl = await refreshSignedUrl({
        signedUrl: url,
        filename: newFileName
      });
      if (!refreshedUrl) {
        throw new Error("Failed to refresh download URL");
      }
      window.location.href = refreshedUrl;
    } catch (error) {
      console.error("Download failed:", error);
      toast({
        title: "Download Failed",
        description: "Unable to download the file. Please try again.",
        variant: "error"
      });
    }
  };
  return {
    download
  };
}